module.exports = __webpack_public_path__ + "media/images/img-avatar-62b6aa29a1a017358599f8f04085fd67.svg";